module.exports = __webpack_public_path__ + "img/ico-exp-c.ecbce3bb.svg";